import moment from 'moment';
import User from '@/shared/models/User';
import TransportDetails, { TransportData } from './TransportDetails';

export default class TransportContainer {
  /**
   * Pickup service = dealer picks up the car at the customer site and takes it to the workshop
   * null = inactive
   */
  pickup: TransportDetails | null = null;

  /**
   * Delivery service = dealer delivers the car back to the customer site once work has been completed
   * null = inactive
   */
  delivery: TransportDetails | null = null;

  modifiedOn = moment();
  modifiedBy: User | null = null;

  update(transportIn: TransportData, transportOut: TransportData, user: User, time = moment()): void {
    this.pickup = TransportDetails.forPickupOrDelivery(transportIn);
    this.delivery = TransportDetails.forPickupOrDelivery(transportOut);
    this.modifiedBy = user;
    this.modifiedOn = time;
  }
}
